/**
 * Created by rxsl-106 on 2017/6/1.
 */
import api from './index';

let exports = {};

// 获取配件定义详情
exports.getAccDefInfo = function (params, callback) {
    api.get('/accStock/def/info/get')
    .params(params)
    .done(callback)
    .go();
};

// 获取配件定义列表
exports.getAccDefList = function (data, callback) {
    api.post('/accStock/def/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveAccDef = function (data, callback) {
    api.post('/accStock/def/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateAccDef = function (data, callback) {
    api.post('/accStock/def/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 获取配件定义列表
exports.getMerchtAccDefListByMerchantId = function (data, callback) {
    api.post('/accStock/mercht/def/list/get/for/select')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchtAccStockList = function (data, callback) {
    api.post('/accStock/mercht/stock/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取配件库存
exports.getAccStockById = function (params, callback) {
    api.get('/accStock/get')
    .params(params)
    .done(callback)
    .go();
};

// 获取配件库存 列表
exports.getAccStockList = function (data, callback) {
    api.post('/accStock/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 配件库存预警设置
exports.updateAccStockForStockValve = function (data, callback) {
    api.post('/accStock/stockValve/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 配件库存预警设置
exports.updateAccStockNormalQuantity = function (data, callback) {
    api.post('/accStock/normalQuantity/update/do')
    .data(data)
    .done(callback)
    .go();
};

/*========================================配件出入库单=======================================================*/

// 查询【配件出入库单】分页列表
exports.getAccIoVoucherList = function (data, callback) {
    api.post('/accStock/acc/io/voucher/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 查询【配件出入库单】
exports.getAccIoVoucherById = function (data, callback) {
    api.post('/accStock/acc/io/voucher/get')
    .data(data)
    .done(callback)
    .go();
};

// 【配件入库单】保存
exports.saveAccIoInVoucher = function (data, callback) {
    api.post('/accStock/acc/io/in/voucher/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 【配件出库单】保存
exports.saveAccIoOutVoucher = function (data, callback) {
    api.post('/accStock/acc/io/out/voucher/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 【配件出入库单】修改
exports.updateAccIoVoucher = function (data, callback) {
    api.post('/accStock/acc/io/voucher/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 【配件出入库单】申请
exports.applyAccIoVoucher = function (data, callback) {
    api.post('/accStock/acc/io/voucher/apply/do')
    .data(data)
    .done(callback)
    .go();
};

// 【配件入库单】审核
exports.auditAccIoInVoucher = function (data, callback) {
    api.post('/accStock/acc/io/in/voucher/audit/do')
    .data(data)
    .done(callback)
    .go();
};
// 【配件出库单】审核
exports.auditAccIoOutVoucher = function (data, callback) {
    api.post('/accStock/acc/io/out/voucher/audit/do')
    .data(data)
    .done(callback)
    .go();
};

// 【配件出入库单】删除
exports.deleteAccIoVoucher = function (data, callback) {
    api.post('/accStock/acc/io/voucher/delete/do')
    .data(data)
    .done(callback)
    .go();
};

// 出库单项列表
exports.getAccIoVoucherItemList = function (data, callback) {
    api.post('/accStock/acc/io/voucher/item/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 查询【配件出入库单审核记录】列表
exports.getAccIoAuditRecList = function (data, callback) {
    api.post('/accStock/acc/io/audit/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 配件盘点保存配件出入库单
exports.upLoadAccStockList = function (data, callback) {
    api.post('/accStock/list/upload/do')
    .data(data)
    .done(callback)
    .go();
};

// ----------------- 商户出入库记录 --------------------
// 配件出入库列表
exports.getAccIoRecordList = function (data, callback) {
    api.post('/accStock/acc/io/record/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 个人配件出入库记录 -统计
exports.getStaffAccIoRecordStatis = function (data, callback) {
    api.post('/accStock/staff/acc/io/record/statis/get')
    .data(data)
    .done(callback)
    .go();
};
// 配件出入库中的品牌列表
exports.getStaffAccStockBrandList = function (data, callback) {
    api.post('/accStock/staff/acc/io/record/brand/list/get')
    .data(data)
    .done(callback)
    .go();
};

// ------------------- 网点库存 ---------------------------
// 查询网点库存记录
exports.getShopAccIoRecordList = function (data, callback) {
    api.post('/accStock/shop/acc/io/record/list/get')
    .data(data)
    .done(callback)
    .go();
};

// ======================== 网点 库存 ==========================

exports.getShopAccStockById = function (params, callback) {
    api.get('/accStock/shop/acc/stock/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getShopAccStockList = function (data, callback) {
    api.post('/accStock/shop/acc/stock/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.updateShopAccStockForStockValue = function (data, callback) {
    api.post('/accStock/shop/acc/stock/stockValve/update/do')
    .data(data)
    .done(callback)
    .go();
};

// ----------------- 配件调拨单 --------------------
//查询【配件调拨单】分页列表
exports.getAccTransVoucherList = function (data, callback) {
    api.post('/accStock/acc/trans/voucher/list/get')
    .data(data)
    .done(callback)
    .go();
};

//查询【配件调拨单】
exports.getAccTransVoucherById = function (data, callback) {
    api.post('/accStock/acc/trans/voucher/get')
    .data(data)
    .done(callback)
    .go();
};

//【配件调拨单】保存
exports.saveAccTransVoucher = function (data, callback) {
    api.post('/accStock/acc/trans/voucher/save/do')
    .data(data)
    .done(callback)
    .go();
};

//【配件调拨单】申请
exports.applyAccTransVoucher = function (data, callback) {
    api.post('/accStock/acc/trans/voucher/apply/do')
    .data(data)
    .done(callback)
    .go();
};

//【配件调拨单】审核
exports.auditAccTransVoucher = function (data, callback) {
    api.post('/accStock/acc/trans/voucher/audit/do')
    .data(data)
    .done(callback)
    .go();
};

//【配件调拨单】修改
exports.updateAccTransVoucher = function (data, callback) {
    api.post('/accStock/acc/trans/voucher/update/do')
    .data(data)
    .done(callback)
    .go();
};

//【配件调拨单】删除
exports.deleteAccTransVoucher = function (data, callback) {
    api.post('/accStock/acc/trans/voucher/delete/do')
    .data(data)
    .done(callback)
    .go();
};

//查询【配件调拨单审核记录】列表
exports.getAccTransAuditRecList = function (data, callback) {
    api.post('/accStock/acc/trans/audit/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 修改数量
exports.updateShopAccStockNormalQuantity = function (data, callback) {
    api.post('/accStock/shop/acc/stock/normalQuantity/update/do')
    .data(data)
    .done(callback)
    .go();
};

// ==================================== 网点配件申领/归还单 ===========================

// 网点配件申领/归还单分页列表
exports.getShopAccAppturnVoucherList = function (data, callback) {
    api.post('/accStock/shop/acc/appturn/voucher/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 根据id获取网点配件申领/归还单信息
exports.getShopAccAppturnVoucher = function (params, callback) {
    api.get('/accStock/shop/acc/appturn/voucher/get')
    .params(params)
    .done(callback)
    .go();
};
// 保存申领单
exports.saveShopAccAppVoucher = function (data, callback) {
    api.post('/accStock/shop/acc/app/voucher/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 申请申领单
exports.applyShopAccAppVoucher = function (data, callback) {
    api.post('/accStock/shop/acc/app/voucher/apply/do')
    .data(data)
    .done(callback)
    .go();
};
// 审核申领单
exports.auditShopAccAppVoucher = function (data, callback) {
    api.post('/accStock/shop/acc/app/voucher/audit/do')
    .data(data)
    .done(callback)
    .go();
};
// 网点领用操作
exports.gainShopAccAppVoucher = function (params, callback) {
    api.post('/accStock/shop/acc/app/voucher/gain/do')
    .data(params)
    .done(callback)
    .go();
};
// 修改网点申领单操作
exports.updateShopAccAppVoucher = function (data, callback) {
    api.post('/accStock/shop/acc/app/voucher/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除申领归还单操作
exports.deleteShopAccAppVoucher = function (params, callback) {
    api.post('/accStock/shop/acc/app/voucher/delete/do')
    .params(params)
    .done(callback)
    .go();
};

// 保存归还单
exports.saveShopAccTurnVoucher = function (data, callback) {
    api.post('/accStock/shop/acc/turn/voucher/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 修改归还单
exports.updateShopAccTurnVoucher = function (data, callback) {
    api.post('/accStock/shop/acc/turn/voucher/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 检查归还单
exports.checkShopAccTurnVoucher = function (data, callback) {
    api.post('/accStock/shop/acc/turn/voucher/check')
    .data(data)
    .done(callback)
    .go();
};
// 申请归还单
exports.applyShopAccTurnVoucher = function (data, callback) {
    api.post('/accStock/shop/acc/turn/voucher/apply/do')
    .data(data)
    .done(callback)
    .go();
};
// 审核归还单
exports.auditShopAccTurnVoucher = function (data, callback) {
    api.post('/accStock/shop/acc/turn/voucher/audit/do')
    .data(data)
    .done(callback)
    .go();
};
// 归还操作
exports.returnShopAccTurnVoucher = function (params, callback) {
    api.post('/accStock/shop/acc/turn/voucher/return/do')
    .data(params)
    .done(callback)
    .go();
};
// 删除归还单
exports.deleteShopAccTurnVoucher = function (params, callback) {
    api.post('/accStock/shop/acc/turn/voucher/delete/do')
    .params(params)
    .done(callback)
    .go();
};
// 网点-附件列表
exports.getShopAccAppturnItemList = function (params, callback) {
    api.get('/accStock/shop/acc/turn/voucher/item/list/get')
    .params(params)
    .done(callback)
    .go();
};
// 网点-附件列表
exports.getShopAccAppturnFileList = function (params, callback) {
    api.post('/accStock/shop/voucher/file/list/get')
    .data(params)
    .done(callback)
    .go();
};
// =============== 个人配件申领归还列表 ===================

exports.getStaffAccAppTurnVoucherList = function (data, callback) {
    api.post('/accStock/staff/voucher/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getStaffAccAppturnVoucherById = function (data, callback) {
    api.get('/accStock/staff/voucher/info/get')
    .params(data)
    .done(callback)
    .go();
};
exports.getStaffAccAppturnVoucherByShareServicerIdList = function (data, callback) {
    api.post('/accStock/staff/voucher/list/get/by/shareServicerId')
    .data(data)
    .done(callback)
    .go();
};
// 查询【个人配件申领/归还单】
exports.getStaffAccAppturnVoucherByServicerIdList = function (data, callback) {
    api.post('/accStock/staff/voucher/list/get/by/servicerId')
    .data(data)
    .done(callback)
    .go();
};
// 【个人配件申领单】审核
exports.auditStaffAccAppVoucher = function (data, callback) {
    api.post('/accStock/staff/acc/app/voucher/audit/do')
    .data(data)
    .done(callback)
    .go();
};
// 【个人配件归还单】审核
exports.auditStaffAccTurnVoucher = function (data, callback) {
    api.post('/accStock/staff/acc/turn/voucher/audit/do')
    .data(data)
    .done(callback)
    .go();
};
// 【个人配件申领单】确认
exports.doneStaffAccAppVoucher = function (data, callback) {
    api.post('/accStock/staff/acc/app/voucher/done/do')
    .data(data)
    .done(callback)
    .go();
};
// 【个人配件归还单】确认
exports.doneStaffAccTurnVoucher = function (data, callback) {
    api.post('/accStock/staff/acc/turn/voucher/done/do')
    .data(data)
    .done(callback)
    .go();
};
// 【个人配件归还单】确认
exports.doneStaffAccTurnVoucherShare = function (data, callback) {
    api.post('/accStock/staff/acc/turn/voucher/share/done/do')
    .data(data)
    .done(callback)
    .go();
};

// 配件定义导入前检查
exports.validateAccDefModel = function (data, callback) {
    api.post('/accStock/def/imp/model/validate')
    .data(data)
    .done(callback)
    .go();
};
// 执行设配件定义导入，返回导入成功数量
exports.doAccDefImpModelImport = function (data, callback) {
    api.post('/accStock/def/imp/model/import/do')
    .data(data)
    .done(callback)
    .go();
};
// 配件转借单详情
exports.getStaffAccPassVoucherInfo = function (data, callback) {
    api.get('/accStock/staff/acc/pass/voucher/get')
    .params(data)
    .done(callback)
    .go();
};
//
exports.getStaffAccPassVoucherList = function (data, callback) {
    api.post('/accStock/staff/acc/pass/voucher/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 个人附件-列表
exports.getStaffAccAppturnFileList = function (data, callback) {
    api.post('/accStock/staff/voucher/file/list/get')
    .data(data)
    .done(callback)
    .go();
};
// ========================= 个体化配件 =============
// 查询个体化配件列表
exports.getSpecificAccList = function (data, callback) {
    api.post('/accStock/specific/acc/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 查询个体化配件
exports.getSpecificAccById = function (params, callback) {
    api.get('/accStock/specific/acc/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
// 批量保存个体化配件
exports.saveSpecificAcc = function (data, callback) {
    api.post('/accStock/specific/acc/batch/save')
    .data(data)
    .done(callback)
    .go();
};
// 报废个体化配件
exports.updateSpecificAccScrapped = function (data, callback) {
    api.post('/accStock/specific/acc/scrapped/update')
    .data(data)
    .done(callback)
    .go();
};
exports.updateSpecificAccRetailerOwned = function (data, callback) {
    api.post('/accStock/specific/acc/retailerOwned/update')
    .data(data)
    .done(callback)
    .go();
};
// 清理
exports.updateSpecificAccForCleared = function (data, callback) {
    api.post('/accStock/specific/acc/cleared/update')
    .data(data)
    .done(callback)
    .go();
};
// 状态转换
exports.updateSpecificAccForDefect = function (data, callback) {
    api.post('/accStock/specific/acc/defect/update')
    .data(data)
    .done(callback)
    .go();
};
exports.updateSpecificAccLocked = function (data, callback) {
    api.post('/accStock/specific/acc/locked/update')
    .data(data)
    .done(callback)
    .go();
};
// 个体配件绑定客户门店
exports.doBoundSpecificAcc = function (data, callback) {
    api.post('/accStock/specific/acc/bound/do')
    .data(data)
    .done(callback)
    .go();
};
// 查询个体化配件记录列表
exports.getSpecificAccRecList = function (data, callback) {
    api.post('/accStock/specific/acc/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 查询个体化配件记录列表
exports.getSpecificAccRecListByVendorSn = function (data, callback) {
    api.post('/accStock/specific/acc/rec/list/get/by/vendorSn')
    .data(data)
    .done(callback)
    .go();
};
// 查询个体化配件记录列表
exports.getSpecificAccRecById = function (params, callback) {
    api.get('/accStock/specific/acc/rec/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
// 查询个体化配件记录
exports.getSpecificAccRecListByVoucherNo = function (params, callback) {
    api.post('/accStock/specific/acc/rec/list/get/by/voucherNo')
    .data(params)
    .done(callback)
    .go();
};

// 个体配件返修单-详情
exports.getSpecificAccRepairVoucherInfo = function (params, callback) {
    api.get('/accStock/specific/acc/repair/voucher/get')
    .params(params)
    .done(callback)
    .go();
};
// 个体配件返修单
exports.getSpecificAccRepairVoucherList = function (params, callback) {
    api.post('/accStock/specific/acc/repair/voucher/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 收货
exports.updateSpecificAccRepairVoucherRecvInfo = function (params, callback) {
    api.post('/accStock/specific/acc/repair/voucher/recvInfo/update/do')
    .data(params)
    .done(callback)
    .go();
};

// =================== 库位码

exports.getAccStoreLocList = function (data, callback) {
    api.post('/accStock/acc/store/loc/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getAccStoreLoc = function (params, callback) {
    api.get('/accStock/acc/store/loc/get')
    .params(params)
    .done(callback)
    .go();
};

exports.saveAccStoreLoc = function (data, callback) {
    api.post('/accStock/acc/store/loc/save')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteAccStoreLoc = function (data, callback) {
    api.post('/accStock/acc/store/loc/delete')
    .data(data)
    .done(callback)
    .go();
};

exports.doAccStoreLocRelAcc = function (data, callback) {
    api.post('/accStock/acc/store/loc/rel/acc/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doAccStoreLocUnRelAcc = function (data, callback) {
    api.post('/accStock/acc/store/loc/unrel/acc/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doAccStoreLocModelImport = function (data, callback) {
    api.post('/accStock/acc/store/loc/imp/model/import/do')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/accStock.js
// module id = 13
// module chunks = 1